/* ============================================================
  HVAC Supplies Homepage JS
  File: assets/hvx-home.js
============================================================ */

(function () {
  function qsa(scope, selector) {
    return Array.prototype.slice.call(scope.querySelectorAll(selector));
  }

  function initSliders(scope) {
    qsa(scope, "[data-hvx-slider]").forEach(function (slider) {
      if (slider.dataset.hvxSliderInit === "1") return;
      slider.dataset.hvxSliderInit = "1";

      var slides = qsa(slider, "[data-hvx-slide]");
      var dots = qsa(slider, "[data-hvx-dot]");
      var prev = slider.querySelector("[data-hvx-prev]");
      var next = slider.querySelector("[data-hvx-next]");
      var autoplay = slider.dataset.autoplay === "true";
      var interval = parseInt(slider.dataset.interval || "6000", 10);
      var index = 0;
      var timer = null;

      if (!slides.length) return;

      function setActive(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;

        slides.forEach(function (slide, i) {
          slide.classList.toggle("is-active", i === index);
        });

        dots.forEach(function (dot, i) {
          dot.classList.toggle("is-active", i === index);
          dot.setAttribute("aria-selected", i === index ? "true" : "false");
        });
      }

      function go(delta) {
        setActive(index + delta);
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        stop();
        if (!autoplay || slides.length < 2) return;
        timer = window.setInterval(function () {
          go(1);
        }, Math.max(2200, interval));
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener("click", function () {
          setActive(i);
          start();
        });
      });

      if (prev) {
        prev.addEventListener("click", function () {
          go(-1);
          start();
        });
      }

      if (next) {
        next.addEventListener("click", function () {
          go(1);
          start();
        });
      }

      slider.addEventListener("mouseenter", stop);
      slider.addEventListener("mouseleave", start);
      slider.addEventListener("focusin", stop);
      slider.addEventListener("focusout", start);

      setActive(0);
      start();
    });
  }

  function initScrollers(scope) {
    qsa(scope, "[data-hvx-scroll-shell]").forEach(function (shell) {
      if (shell.dataset.hvxScrollInit === "1") return;
      shell.dataset.hvxScrollInit = "1";

      var scroller = shell.querySelector("[data-hvx-scroll]");
      var prev = shell.querySelector("[data-hvx-scroll-prev]");
      var next = shell.querySelector("[data-hvx-scroll-next]");
      if (!scroller) return;

      function getStep() {
        var first = scroller.children[0];
        if (!first) return Math.round(scroller.clientWidth * 0.85);
        var rect = first.getBoundingClientRect();
        return Math.max(180, Math.round(rect.width + 14));
      }

      function maxScroll() {
        return scroller.scrollWidth - scroller.clientWidth;
      }

      function update() {
        var max = maxScroll();
        var x = scroller.scrollLeft;

        if (prev) prev.disabled = max <= 2 || x <= 2;
        if (next) next.disabled = max <= 2 || x >= max - 2;
      }

      if (prev) {
        prev.addEventListener("click", function () {
          scroller.scrollBy({ left: -getStep(), behavior: "smooth" });
        });
      }

      if (next) {
        next.addEventListener("click", function () {
          scroller.scrollBy({ left: getStep(), behavior: "smooth" });
        });
      }

      scroller.addEventListener("scroll", function () {
        window.requestAnimationFrame(update);
      }, { passive: true });

      window.addEventListener("resize", update, { passive: true });

      qsa(scroller, "img").forEach(function (img) {
        if (!img.complete) {
          img.addEventListener("load", update, { once: true });
        }
      });

      update();
      window.setTimeout(update, 250);
      window.setTimeout(update, 900);
    });
  }

  function boot(scope) {
    initSliders(scope || document);
    initScrollers(scope || document);
  }

  document.addEventListener("DOMContentLoaded", function () {
    boot(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target || document);
  });
})();